import { Component, Input, OnInit } from "@angular/core";

import * as fromStore from "../../../../store";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import { GematikProfile } from "../../../../models/profile.model";

@Component({
    selector: "profile-display",
    styleUrls: ["profile-display.component.scss"],
    template: `
    <div class="d-flex justify-content-center mt-2" style="width: 100%; ">
      <a *ngIf="profile$ | async as profile; else avatarSkeleton" href="" routerLink="profile"
        ><img [src]="getAvatar(profile)" [ngClass]="isExpanded ? 'avatar' : 'avatar-small'" />
      </a>
      <ng-template #avatarSkeleton>
        <gem-loading-placeholder [compact]="true" [error]="profileError$ | async" (retry)="onRetry()">
          <gem-skeleton
            variant="circle"
            [width]="isExpanded ? '80px' : '40px'"
            [height]="isExpanded ? '80px' : '40px'"
          ></gem-skeleton>
        </gem-loading-placeholder>
      </ng-template>
    </div>
    <div class="d-flex justify-content-center mt-2" style="width: 100%">
      <a href="" routerLink="profile" class="gem-link-blue">
        <p data-testid="fullname" *ngIf="isExpanded" class="gem-color-blue fw-bold">
          {{ (profile$ | async)?.firstName }} {{ (profile$ | async)?.lastName }}
        </p>
        <p data-testid="initials" *ngIf="!isExpanded" class="gem-color-blue fw-bold">
          {{ getInitials(profile$ | async) }}
        </p>
      </a>
    </div>
    <div *ngIf="isExpanded" class="d-flex justify-content-center mt-2" style="width: 100%">
      <div class="pt-1 pb-1 ps-3 pe-3 gem-bg-color-light-grey" style="border-radius: 50px">
        <span class="fs-6 gem-color-dark-grey">{{ (profile$ | async)?.organisation }}</span>
      </div>
    </div>
  `,
    standalone: false
})
export class ProfileDisplayComponent implements OnInit {
  @Input() isExpanded: boolean;

  profile$: Observable<GematikProfile>;
  profileError$: Observable<boolean>;

  constructor(private store: Store<fromStore.UwlState>) {}

  ngOnInit(): void {
    this.profile$ = this.store.select(fromStore.getProfile);
    this.profileError$ = this.store.select(fromStore.getProfileError);
  }

  onRetry(): void {
    this.store.dispatch(fromStore.LoadProfile());
  }

  getInitials(profile: GematikProfile): string {
    if (profile) {
      const fullName = profile.firstName + " " + profile.lastName;
      return fullName
        .split(" ")
        .map((n) => n[0])
        .join("");
    }
    return "Anonymous";
  }

  getAvatar(profile: GematikProfile): string {
    if (profile) {
      return `data:${profile.avatar?.mimeType};base64,${profile.avatar?.data}`;
    }
    return null;
  }
}
